import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import icon from '../../../src/assets/location_on_24px.svg';


export class MapContainer extends Component{

  constructor(props){
    super(props);
    
    }
  
  render(){
    // If there is no GPS data just show a map with the location marker
    if (!this.props.gpsActions || this.props.gpsActions.length === 0) {
      return (
        <Map id="map"
             google={this.props.google}
             zoom={17}
             style={{height: '100%', width: '100%', marginRight: 0}}
             initialCenter={{
               lat: this.props.location.lat,
               lng: this.props.location.lng
             }}
             center={{
               lat: this.props.location.lat,
               lng: this.props.location.lng
             }}
             disableDefaultUI={true}
             zoomControl={true}
        >
          <Marker
            title={this.props.location.name}
            name={this.props.location.name}
            position={{lat: this.props.location.lat, lng: this.props.location.lng}}
          />
        </Map>
      );
    } else {
      return (
        <Map id="map"
             google={this.props.google}
             zoom={17}
             style={{height: '100%', width: '100%', marginRight: 0}}
             center={{
               lat: this.props.location.lat,
               lng: this.props.location.lng
             }}
             initialCenter={{
               lat: this.props.location.lat,
               lng: this.props.location.lng
             }}
             disableDefaultUI={true}
             zoomControl={true}
        >
          <Marker
            title={this.props.location.name}
            name={this.props.location.name}
            position={{lat: this.props.location.lat, lng: this.props.location.lng}}
          />

          {this.props.gpsActions.map((record) => {
            return (
              <Marker
                key={record.id}
                title={record.transactionType}
                position={{lat: record.latitude, lng: record.longitude}}
              />
            );
          })}
        </Map>
      );
    }
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyDjDO8PpZj3IHeQtGpVmwjJPKASgrutPiY'
})(MapContainer)